const settings = {

    // StartSetting
//StartSetting
settingsOverview: {
  title: 'Einstellungsübersicht',
  subtitle:
    'Verwalte dein Elnydo-Konto, Datenschutz, Sicherheit und Profilfunktionen an einem zentralen Ort.',

  cards: {
    account: {
      title: 'Kontoeinstellungen',
      pill: 'Grundlagen',
      desc:
        'Aktualisiere deine E-Mail-Adresse und dein Passwort, wähle die App-Sprache und pausiere die Sichtbarkeit deines Profils.',
      item1: 'E-Mail-Adresse ändern',
      item2: 'Passwort ändern',
      item3: 'Sprache & Lokalisierung',
      item4: 'Öffentliches Profil pausieren',
      cta: 'Kontoeinstellungen öffnen',
    },

    privacy: {
      title: 'Daten & Datenschutz',
      pill: 'Wichtig',
      desc:
        'Verwalte den Standortzugriff, Push-Benachrichtigungen, anonyme Analysen und deine gespeicherten Daten.',
      item1: 'Standortzugriff erlauben oder deaktivieren',
      item2: 'Push-Benachrichtigungseinstellungen',
      item3: 'Anonyme Analysen aktivieren/deaktivieren',
      item4: 'Alle gespeicherten Daten anzeigen',
      item5: 'Datenschutzerklärung & Konto löschen',
      cta: 'Daten & Datenschutz öffnen',
    },

    security: {
      title: 'Sicherheit',
      pill: 'Schutz',
      desc:
        'Schütze dein Konto zusätzlich mit der Zwei-Faktor-Authentifizierung und verwalte aktive Anmeldungen auf deinen Geräten.',
      item1: 'Zwei-Faktor-Authentifizierung aktivieren/verwalten',
      item2: '2FA-Wiederherstellungscodes anzeigen',
      item3: 'Von allen Geräten abmelden',
      cta: 'Sicherheitseinstellungen öffnen',
    },

    profileMgmt: {
      title: 'Profilverwaltung',
      pill: 'Aktivität',
      desc:
        'Verwalte deine Beiträge, Follower und Abonnements, überprüfe Benachrichtigungen und verwalte blockierte Benutzer.',
      item1: 'Eigene Beiträge anzeigen',
      item2: 'Benachrichtigungsübersicht',
      item3: 'Follower- & Abonnementlisten',
      item4: 'Blockierte Benutzer verwalten',
      cta: 'Profilverwaltung öffnen',
    },

    help: {
      title: 'Hilfe & Support',
      pill: 'Support',
      desc:
        'Kontaktiere das Elnydo-Team, wenn du Hilfe benötigst, ein Problem melden oder Feedback geben möchtest.',
      item1: 'Elnydo-Support kontaktieren',
      item2: 'Probleme oder Missbrauch melden',
      item3: 'Feedback & Ideen senden',
      cta: 'Hilfe & Support öffnen',
    },

    policies: {
      title: 'Richtlinien',
      pill: 'Rechtliches',

      desc:
        'Erfahre, wie Elnydo funktioniert, wie deine Daten verarbeitet werden und welche Regeln für die Nutzung der Plattform gelten.',

      item1: 'Datenschutzerklärung lesen',
      item2: 'Nutzungsbedingungen lesen',

      privacyCta: 'Datenschutzerklärung',
      termsCta: 'Nutzungsbedingungen',
    },
  },
},

//SecuritySettings
securitySettings: {
  page: {
    title: 'Sicherheit',
    subtitle: 'Verwalte die Zwei-Faktor-Authentifizierung und aktive Sitzungen.',
  },

  loadError: {
    unauthenticated: 'Du bist nicht angemeldet. Bitte melde dich erneut an.',
    statusLoadFallback: 'Der Status der Zwei-Faktor-Authentifizierung konnte nicht geladen werden.',
  },

  twoFA: {
    sectionTitle: 'Zwei-Faktor-Authentifizierung (E-Mail)',
    statusLabel: 'Status:',
    statusEnabled: 'Aktiviert',
    statusDisabled: 'Deaktiviert',
    manageButton: '2FA verwalten (E-Mail)',
    disableButton: '2FA deaktivieren',
    loading: 'Sicherheitsstatus wird geladen…',
    enableHint: 'Klicke auf „2FA verwalten (E-Mail)“, um sie zu aktivieren — Passwort → E-Mail → OTP.',

    alerts: {
      disableMissingPassword: 'Gib dein Passwort ein, um die 2FA zu deaktivieren.',
      disableSuccess: '2FA wurde deaktiviert.',
      disableError: '2FA konnte nicht deaktiviert werden.',
      logoutAllConfirm: 'Von allen Geräten abmelden?',
      logoutAllSuccess: '✅ Alle Sitzungen wurden beendet. Bitte melde dich erneut an.',
      logoutAllError: 'Sitzungen konnten nicht beendet werden.',
    },
  },

  twoFAWizard: {
    modalTitle: '2FA aktivieren (E-Mail)',

    errors: {
      missingPassword: 'Bitte gib dein aktuelles Passwort ein.',
      missingEmails: 'Bitte gib deine E-Mail-Adresse ein und bestätige sie.',
      emailMismatch: 'Die E-Mail-Adressen stimmen nicht überein.',
      invalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',
      sendFailed: 'Der Bestätigungscode konnte nicht gesendet werden.',
      unauthenticatedSuffix: '(Nicht authentifiziert – wurde dein Token gespeichert?)',
      missingOtp: 'Gib den 6-stelligen Code ein, den wir dir gesendet haben.',
      verifyFailed: 'Überprüfung fehlgeschlagen.',
    },

    steps: {
      passwordTitle: 'Schritt 1 — Passwort bestätigen',
      passwordPlaceholder: 'Aktuelles Passwort',

      emailTitle: 'Schritt 2 — E-Mail-Adresse für deine 2FA-Codes auswählen',
      emailPlaceholder: 'du@beispiel.de',
      emailConfirmPlaceholder: 'E-Mail bestätigen',
      emailTip:
        'Tipp: Du kannst deine Konto-E-Mail-Adresse verwenden, wenn du keine separate Adresse nutzen möchtest.',

      otpTitlePrefix: 'Schritt 3 — Gib den 6-stelligen Code ein, den wir gesendet haben an',

      otpPlaceholder: '123456',

      doneMessage: '✅ Die Zwei-Faktor-Authentifizierung wurde erfolgreich aktiviert.',
    },

    buttons: {
      cancel: 'Abbrechen',
      continue: 'Weiter',
      back: 'Zurück',
      sendCodeIdle: 'Code senden',
      sendCodeBusy: 'Wird gesendet…',
      verifyEnableIdle: 'Bestätigen & aktivieren',
      verifyEnableBusy: 'Wird überprüft…',
      close: 'Schließen',
    },
  },

  recoveryCodes: {
    sectionTitle: 'Wiederherstellungscodes speichern',
    description:
      'Bewahre diese Codes sicher auf. Sie können verwendet werden, wenn du keinen Zugriff mehr auf deine E-Mail-Adresse hast.',
    fileHeader: 'Deine Wiederherstellungscodes (sicher aufbewahren)',
    fileGeneratedLabel: 'Erstellt:',
    downloadButton: '.txt herunterladen',
    copyButton: 'In Zwischenablage kopieren',
    dismissButton: 'Schließen',
    copySuccess: 'In die Zwischenablage kopiert.',
    copyError: 'Kopieren fehlgeschlagen.',
  },

  sessions: {
    sectionTitle: 'Aktive Sitzungen',
    description: 'Melde alle angemeldeten Geräte ab. Danach musst du dich hier erneut anmelden.',
    buttonIdle: '🔒 Von allen Geräten abmelden',
    buttonBusy: 'Wird abgemeldet…',
  },

  disableModal: {
    title: '2FA deaktivieren',
    description: 'Gib dein Passwort ein, um die Zwei-Faktor-Authentifizierung zu deaktivieren.',
    passwordLabel: 'Passwort',
    passwordPlaceholder: '••••••••',
    cancelButton: 'Abbrechen',
    confirmButtonIdle: 'Deaktivierung bestätigen',
    confirmButtonBusy: 'Wird deaktiviert…',
  },
},

// ProfileManagement
profileManagement: {
  page: {
    title: 'Profilverwaltung',
    subtitle: 'Verwalte dein Profil, Beiträge, Follower, Favoriten und blockierte Benutzer.',
  },
  buttons: {
    profile: 'Mein Profil',
    postings: 'Meine Beiträge',
    notifications: 'Benachrichtigungen',
    favorites: 'Meine Favoriten',
    followers: 'Follower',
    blocked: 'Blockierte Benutzer',
  },
},

//Data Privacy
dataPrivacy: {
  page: {
    title: 'Daten & Datenschutz',
    subtitle: 'Verwalte optionale Datenverarbeitung, exportiere deine Daten oder lösche dein Konto.',
  },

  intro: {
    mainText:
      'Einige Datenverarbeitungen sind erforderlich, um den Dienst bereitzustellen (z. B. Konto, Sicherheit und Missbrauchsprävention) und erfolgen auf Grundlage der Vertragserfüllung oder berechtigter Interessen. Die unten aufgeführten Verarbeitungen basieren auf deiner Einwilligung und sind optional.',
    legalSeeOur: 'Siehe unsere',
    and: 'und',
    privacyLinkLabel: 'Datenschutzerklärung',
    subprocessorsLinkLabel: 'Unterauftragsverarbeiter',
  },

  essential: {
    title: 'Erforderliche Datenverarbeitung',
    description:
      'Kontoverwaltung, Sicherheit, Integrität des Dienstes und nicht personalisierte Betriebsfunktionen. Diese Verarbeitung kann nicht deaktiviert werden.',
    badgeLabel: 'Erforderlich',
  },

  optional: {
    sectionTitle: 'Optionale Datenverarbeitung',
    loading: 'Wird geladen…',
    saving: 'Wird gespeichert…',
    lastSaved: 'Zuletzt gespeichert: {{timestamp}}',

    toggles: {
      yes: 'Ja',
      no: 'Nein',

      analyticsTitle: 'Anonyme Analysen',
      analyticsDescription:
        'Hilft uns, die Nutzung der Funktionen anonym und zusammengefasst zu verstehen. Keine Drittanbieter-Werbetracker.',

      pushTitle: 'Push-Benachrichtigungen',
      pushDescription:
        'Erhalte App-Benachrichtigungen für Nachrichten und Aktivitäten. Zusätzlich gelten die Einstellungen deines Betriebssystems.',

      locationTitle: 'Gerätestandort für Funktionen',
      locationDescription:
        'Wird verwendet, um Beiträge mit Stadt- und Landesinformationen zu versehen und Inhalte in deiner Nähe anzuzeigen. Du kannst die Berechtigung jederzeit in den Geräteeinstellungen widerrufen.',
    },

    alerts: {
      saveError: '❌ Einstellungen konnten nicht gespeichert werden.',
    },
  },

  deletion: {
    sectionTitle: 'Konto & alle Daten löschen',
    warnLine1: 'Dadurch werden dein Konto und sämtliche Daten sofort und dauerhaft gelöscht.',
    warnLine2: 'Dieser Vorgang kann nicht rückgängig gemacht werden.',
    buttonLabel: '🗑️ Mein Konto und alle Daten löschen',

    pwModalTitle: 'Passwort bestätigen',
    pwModalDescription:
      'Bitte gib dein Kontopasswort ein. Wir senden dir anschließend einen 6-stelligen Bestätigungscode per E-Mail. Nach Eingabe dieses Codes werden dein Konto und alle Daten dauerhaft gelöscht.',
    pwPlaceholder: 'Passwort eingeben',
    pwSendCodeIdle: 'Code senden',
    pwSendCodeBusy: 'Wird gesendet…',
    pwCancel: 'Abbrechen',

    otpModalTitle: '6-stelligen Code eingeben',
    otpModalDescription:
      'Mit der Eingabe dieses Codes werden dein Konto und alle Daten sofort und dauerhaft gelöscht.',
    otpPlaceholder: '••••••',
    otpDeleteIdle: 'Jetzt löschen',
    otpDeleteBusy: 'Wird gelöscht…',
    otpCancel: 'Abbrechen',

    alerts: {
      missingPassword: 'Bitte gib dein Passwort ein.',
      startError: 'Der Löschvorgang konnte nicht gestartet werden.',
      missingOtp: 'Bitte gib den 6-stelligen Code ein.',
      verifyError: 'Überprüfung fehlgeschlagen.',
    },
  },

  export: {
    sectionTitle: 'Deine Datenschutzrechte',
    description: 'Du kannst jederzeit eine Kopie deiner Daten exportieren.',
    buttonLabel: '📦 Meine Daten exportieren',
    alerts: {
      exportError: '❌ Deine Daten konnten nicht exportiert werden.',
    },
  },

  policySection: {
    sectionTitle: 'Datenschutzerklärung',
    description: 'Lies die vollständigen Informationen darüber, wie wir deine Daten verarbeiten und schützen.',
    buttonLabel: '📄 Datenschutzerklärung anzeigen',
  },
},

//Account Settings
accountSettings: {
  page: {
    title: 'Kontoeinstellungen',
    subtitle:
      'Verwalte dein Profil, deine E-Mail-Adresse, dein Passwort, die Sprache und die Sichtbarkeit deines Profils.',
  },

  profileName: {
    sectionTitle: 'Profilname',
    sectionDescription: 'Dein öffentlicher Profilname. Er kann nicht geändert werden.',
    label: 'Profilname (nicht änderbar)',
    shareButton: 'Per E-Mail teilen',

    shareModalTitle: 'Profil per E-Mail teilen',
    shareModalDescription:
      'Gib die E-Mail-Adresse des Empfängers ein. Wir öffnen dein E-Mail-Programm mit einer vorbereiteten Nachricht.',
    shareRecipientLabel: 'Empfänger-E-Mail',
    shareRecipientPlaceholder: 'empfaenger@beispiel.de',
    shareCancel: 'Abbrechen',
    shareSubmit: 'Teilen',
    shareSubmitting: 'Wird geöffnet…',
    shareInvalidEmail: 'Bitte gib eine gültige E-Mail-Adresse ein.',

    mailSubject: "Schau dir das Profil von {{name}} an",
    mailBody:
      "Hallo,\n\nHier ist mein Profil:\n\nName: {{name}}\nProfil öffnen: {{link}}\n\n",
  },

  emailChange: {
    sectionTitle: 'E-Mail-Adresse ändern',
    sectionDescription:
      'Starte die Änderung deiner E-Mail-Adresse und bestätige sie mit einem 6-stelligen Code, der an deine neue Adresse gesendet wird.',
    currentEmail: 'Aktuelle E-Mail-Adresse',
    newEmail: 'Neue E-Mail-Adresse',
    missingNewEmail: 'Bitte gib deine neue E-Mail-Adresse ein.',

    validationInvalid: 'Bitte gib eine gültige E-Mail-Adresse ein.',
    validationSame: 'Die neue E-Mail-Adresse muss sich von der aktuellen unterscheiden.',
    startButton: 'E-Mail-Adresse ändern',
    startButtonLoading: 'Wird gestartet…',

    startSuccess:
      '✅ Wir haben einen 6-stelligen Code an deine NEUE E-Mail-Adresse gesendet. Außerdem haben wir deine bisherige E-Mail-Adresse benachrichtigt.',

    otpModalTitle: 'Neue E-Mail-Adresse bestätigen',
    otpModalDescription: 'Gib den 6-stelligen Code ein, den wir an {{email}} gesendet haben.',
    otpLabel: 'Bestätigungscode',
    fallbackEmail: 'deine neue E-Mail-Adresse',

    otpCancel: 'Abbrechen',
    otpResend: 'Erneut senden',
    otpResending: 'Wird erneut gesendet…',
    otpVerify: 'Bestätigen',
    otpVerifying: 'Wird überprüft…',

    otpMissing: 'Bitte gib den 6-stelligen Code ein.',
    otpSuccess: '✅ E-Mail-Adresse aktualisiert.',
    otpError: '❌ Überprüfung fehlgeschlagen.',
    otpResendSuccess: 'Ein neuer Code wurde gesendet.',
    otpResendError: 'Der Code konnte nicht erneut gesendet werden.',

    passwordconfirmpassword: 'Gib dein aktuelles Passwort ein, um fortzufahren.',
    currentpassword: 'Aktuelles Passwort',
  },

  password: {
    sectionTitle: 'Passwort ändern',
    sectionDescription:
      'Aktualisiere dein Passwort in einem zweistufigen Ablauf (aktuelles → neues Passwort).',
    sectionButton: 'Passwort ändern…',

    alerts: {
      missingCurrentFields: 'Bitte gib dein aktuelles Passwort ein.',
      success: '✅ Passwort erfolgreich geändert.',
      error: '❌ Passwort konnte nicht geändert werden.',
      currentIncorrect: 'Das aktuelle Passwort ist nicht korrekt.',
    },
  },

  passwordFlow: {
    titleConfirm: 'Passwort bestätigen',
    titleChooseNew: 'Neues Passwort wählen',

    enterCurrentHint: 'Gib dein aktuelles Passwort ein, um fortzufahren.',
    currentLabel: 'Aktuelles Passwort',
    currentPlaceholder: 'Aktuelles Passwort',

    policyHint: 'Verwende mindestens 8 Zeichen und mindestens eine Zahl.',
    newLabel: 'Neues Passwort',
    newPlaceholder: 'Mindestens 8 Zeichen, inkl. einer Zahl',

    confirmLabel: 'Neues Passwort bestätigen',
    confirmPlaceholder: 'Neues Passwort wiederholen',

    chipOk: '✓',
    chipBad: '✕',
    chipLen: 'Mindestens 8 Zeichen',
    chipDigit: 'Mindestens 1 Zahl',
    chipMatch: 'Passwörter stimmen überein',

    updating: 'Wird aktualisiert…',
    updatePassword: 'Passwort aktualisieren',

    successTitle: 'Passwort aktualisiert',
    successBody: 'Dein Passwort wurde erfolgreich geändert.',
    done: 'Fertig',
  },

  pauseProfile: {
    deactivateModalTitle: 'Deaktivierung bestätigen',
    deactivateModalDescription:
      'Gib dein aktuelles Passwort ein, um dein Profil zu deaktivieren. Du kannst es jederzeit wieder aktivieren.',
    deactivateModalLabel: 'Aktuelles Passwort',

    modalCancel: 'Abbrechen',
    modalDeactivating: 'Wird deaktiviert…',
    modalDeactivate: 'Deaktivieren',

    statusDeactivated: 'Dein Profil ist derzeit deaktiviert.',
    statusActive: 'Dein Profil ist aktiv.',
    since: ' (seit {{date}})',

    deactivateButton: 'Profil deaktivieren...',
    reactivateButton: 'Profil wieder aktivieren...',
    reactivating: 'Wird reaktiviert...',

    alerts: {
      missingPassword: 'Bitte gib dein aktuelles Passwort ein.',
      deactivatedSuccess: '✅ Konto erfolgreich deaktiviert.',
      deactivatedError: '❌ Konto konnte nicht deaktiviert werden.',
      reactivatedSuccess: '✅ Konto erfolgreich reaktiviert.',
      reactivatedError: '❌ Konto konnte nicht reaktiviert werden.',
    },

    reactivateConfirm: {
      title: 'Profil reaktivieren',
      body: 'Möchtest du dein Profil wirklich wieder aktivieren?',
      yesBusy: 'Wird reaktiviert...',
      error: 'Das Profil konnte nicht reaktiviert werden. Bitte versuche es erneut.',
    },
  },

  pageAlerts: {
    saveSuccess: '✅ Kontoeinstellungen gespeichert!',
    saveError: '❌ Kontoeinstellungen konnten nicht gespeichert werden.',
  },

  language: {
    sectionTitle: 'Sprache',
    sectionDescription: 'Wähle deine bevorzugte Sprache für die App-Oberfläche.',
    saveButtonIdle: 'Sprache speichern',
    saveButtonLoading: 'Wird gespeichert…',

    pauseprofile: 'Profil deaktivieren',
    pausedescr: 'Blende dein Profil vorübergehend aus. Du kannst es jederzeit wieder aktivieren.',

    alerts: {
      success: '✅ Sprache gespeichert!',
      error: '❌ Sprache konnte nicht gespeichert werden.',
    },

    // Display names in their own language
    options: {
      en: 'English',
      de: 'Deutsch',
      fr: 'Français',
      es: 'Español',
      pt: 'Português',
      nl: 'Nederlands',
      it: 'Italiano',
      pl: 'Polski',

      hu: 'Magyar',
      cs: 'Čeština',
      ru: 'Русский',
      uk: 'Українська',

      ja: '日本語',
      ko: '한국어',
      ar: 'العربية',
      vi: 'Tiếng Việt',

      tr: 'Türkçe',
      zh: '中文',
    },
  },
},
} as const;
  
  export default settings;
  